import axios from "@/services/config";
import store from "@/store/index";

const codigoPais = () => store.state.gpais.dbPais.IdT;

export const listarOpcionesFuncionAdicional = async () => {
  const gpais = codigoPais();
  const { data, status } = await axios
    .get(`/garantto/${gpais}/funciones-adicionales/opciones`)
    .catch((e) => e.response);
  return { data, status };
};

export const crearLicenciaFuncionAdicional = async (idLicencia, datos) => {
  const gpais = codigoPais();
  const { data, status } = await axios
    .post(`/garantto/${gpais}/licencias/${idLicencia}/funciones-adicionales`, {
      IdFuncionAdicional: datos.IdFuncionAdicional,
      IdFuncionAdicionalEstado: datos.IdFuncionAdicionalEstado,
    })
    .catch((e) => e.response);
  return { data, status };
};

export const actualizarLicenciaFuncionAdicional = async (idLicencia, datos) => {
  const gpais = codigoPais();
  const { data, status } = await axios
    .put(
      `/garantto/${gpais}/licencias/${idLicencia}/funciones-adicionales/${datos.Id}`,
      {
        IdFuncionAdicional: datos.IdFuncionAdicional,
        IdFuncionAdicionalEstado: datos.IdFuncionAdicionalEstado,
      }
    )
    .catch((e) => e.response);
  return { data, status };
};

export const eliminarLicenciaFuncionAdicional = async (idLicencia, id) => {
  const gpais = codigoPais();
  const { data, status } = await axios
    .delete(
      `/garantto/${gpais}/licencias/${idLicencia}/funciones-adicionales/${id}`
    )
    .catch((e) => e.response);
  return { data, status };
};
